import { render, staticRenderFns } from "./record-detail-panel.vue?vue&type=template&id=9f894b84&scoped=true&"
import script from "./record-detail-panel.vue?vue&type=script&lang=js&"
export * from "./record-detail-panel.vue?vue&type=script&lang=js&"
import style0 from "./record-detail-panel.vue?vue&type=style&index=0&id=9f894b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f894b84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
